/*
 * This component provides support for components that
 * use infinite scrolling. It renders nothing by itself.
 *
 * @param {String} elementSelector - the element that is scrollable and used to check the heights against
 * @param {Action} scrolledToBottom - called when scrolled 100px from the bottom of the element
 */
import { scheduleOnce } from '@ember/runloop';
import Component from '@ember/component';
export default class InfiniteScrollModalContent extends Component {
  didInsertElement() {
    super.didInsertElement();
    const element = document.querySelector(this.elementSelector);
    element.addEventListener('scroll', () => this.checkScrollPosition());
    element.addEventListener('wheel', () => this.checkScrollPosition());
    element.addEventListener('mousewheel', () => this.checkScrollPosition());
    scheduleOnce('afterRender', this, 'checkScrollPosition');
  }
  checkScrollPosition() {
    if (this.isDestroyed || this.isDestroying) {
      return;
    }
    const element = document.querySelector(this.elementSelector);
    if (element.scrollHeight - element.clientHeight - element.scrollTop <= 100) {
      this.scrolledToBottom();
    }
  }
}